<script setup lang="ts">
interface Props {
  secondary?: boolean
}
withDefaults(defineProps<Props>(), {
  secondary: false,
})
</script>

<template>
  <button class="chip" :class="{ chip_secondary: secondary }">
    <slot name="start" />
    <div class="chip__text">
      <slot />
    </div>
    <slot name="end" />
  </button>
</template>

<style scoped lang="scss">
.chip {
  position: relative;
  padding: 0px 12px;
  padding-right: 8px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 28px;
  @include h5-6;
  @extend %hover-transition;
  background-color: $white;
  color: #008443;
  --svg-col: #{$primary-green};

  &__text {
    white-space: nowrap;
  }

  &_secondary {
    background-color: $sub-green;
  }
}
</style>
